import React from 'react';
import { TableWrapper } from './TableWrapper';
interface HologramTabProps {
  searchTerm: string;
}
export function HologramTab({
  searchTerm
}: HologramTabProps) {
  const holograms = [{
    bodyPart: 'Head',
    primary: 'Lieque (LU 7)',
    alternatives: 'Baihui (GV 20)',
    location: 'Radial styloid process',
    notes: 'Master point for all head conditions. Use for headaches, dizziness, mental clarity.'
  }, {
    bodyPart: 'Face',
    primary: 'Sanjian (LI 3)',
    alternatives: 'Hegu (LI 4)',
    location: '2nd metacarpal radial side',
    notes: 'Facial paralysis, TMJ, facial pain, cosmetic acupuncture.'
  }, {
    bodyPart: 'Eyes',
    primary: 'Dubi (ST 35)',
    alternatives: 'Quchi (LI 11), Xingjian (LR 2), Ququan (LR 8)',
    location: 'Lateral knee depression',
    notes: 'All eye disorders, vision problems, eye inflammation.'
  }, {
    bodyPart: 'Nose',
    primary: 'Yingxiang (LI 20)',
    alternatives: 'Bitong (EX-HN8), Hegu (LI 4)',
    location: 'Nasolabial groove',
    notes: 'Sinusitis, rhinitis, nasal congestion, anosmia.'
  }, {
    bodyPart: 'Ears',
    primary: 'Tinggong (SI 19)',
    alternatives: 'Ermen (TH 21), Tinghui (GB 2)',
    location: 'Anterior to ear',
    notes: 'Deafness, tinnitus, ear infections, hearing loss.'
  }, {
    bodyPart: 'Throat',
    primary: 'Jiexi (ST 41)',
    alternatives: 'Zhongfeng (LR 4), Shangqiu (SP 5), Daling (PC 7)',
    location: 'Ankle dorsiflexion crease',
    notes: 'Sore throat, laryngitis, voice disorders, throat inflammation.'
  }, {
    bodyPart: 'Neck',
    primary: 'Xuanzhong (GB 39)',
    alternatives: 'Fengchi (GB 20), Dazhui (GV 14)',
    location: '3 cun above lateral malleolus',
    notes: 'Neck pain, stiffness, cervical problems.'
  }, {
    bodyPart: 'Chest',
    primary: 'Neiguan (PC 6)',
    alternatives: 'Shanzhong (REN 17), Zhongfu (LU 1)',
    location: '2 cun above wrist crease',
    notes: 'Chest pain, asthma, heart problems, anxiety.'
  }, {
    bodyPart: 'L2/Lumbar Waistline',
    primary: 'Baihui (GV 20)',
    alternatives: 'Weizhong (BL 40), Linggu (T 22.05)',
    location: 'Vertex of head',
    notes: 'CRITICAL point for lower back pain, especially L2 region.'
  }, {
    bodyPart: 'Lower Back',
    primary: 'Houxi (SI 3)',
    alternatives: 'Shenshu (BL 23), Yaoyangguan (GV 3)',
    location: '5th metacarpal ulnar side',
    notes: 'Lower back pain, sciatica, lumbar problems.'
  }, {
    bodyPart: 'Kidneys',
    primary: 'Taixi (KI 3)',
    alternatives: 'Shenshu (BL 23), Mingmen (GV 4)',
    location: 'Medial ankle depression',
    notes: 'Kidney deficiency, urinary problems, reproductive issues.'
  }, {
    bodyPart: 'Bladder',
    primary: 'Weizhong (BL 40)',
    alternatives: 'Zhongji (REN 3), Pangguangshu (BL 28)',
    location: 'Popliteal crease center',
    notes: 'UTI, cystitis, bladder retention, incontinence.'
  }, {
    bodyPart: 'Liver',
    primary: 'Taichong (LR 3)',
    alternatives: 'Ganshu (BL 18), Qimen (LR 14)',
    location: '1st-2nd metatarsal junction',
    notes: 'Liver qi stagnation, hepatitis, emotional problems.'
  }, {
    bodyPart: 'Gallbladder',
    primary: 'Yanglingquan (GB 34)',
    alternatives: 'Danshu (BL 19), Riyue (GB 24)',
    location: 'Fibula head depression',
    notes: 'Gallbladder disorders, lateral body pain, sinews.'
  }, {
    bodyPart: 'Spleen',
    primary: 'Taibai (SP 3)',
    alternatives: 'Pishu (BL 20), Zhangmen (LR 13)',
    location: '1st metatarsal base',
    notes: 'Digestive problems, worry, dampness, blood deficiency.'
  }, {
    bodyPart: 'Stomach',
    primary: 'Zusanli (ST 36)',
    alternatives: 'Weishu (BL 21), Zhongwan (REN 12)',
    location: '3 cun below ST 35',
    notes: 'All digestive disorders, gastritis, poor appetite.'
  }, {
    bodyPart: 'Lungs',
    primary: 'Taiyuan (LU 9)',
    alternatives: 'Feishu (BL 13), Zhongfu (LU 1)',
    location: 'Radial artery wrist crease',
    notes: 'Respiratory problems, asthma, chronic cough.'
  }, {
    bodyPart: 'Heart',
    primary: 'Shenmen (HT 7)',
    alternatives: 'Xinshu (BL 15), Shanzhong (REN 17)',
    location: 'Wrist crease ulnar side',
    notes: 'Heart disease, anxiety, insomnia, palpitations.'
  }, {
    bodyPart: 'Small Intestine',
    primary: 'Yanggu (SI 5)',
    alternatives: 'Xiaochangshu (BL 27), Guanyuan (REN 4)',
    location: 'Wrist ulnar side depression',
    notes: 'Abdominal pain, intestinal disorders, malabsorption.'
  }, {
    bodyPart: 'Large Intestine',
    primary: 'Hegu (LI 4)',
    alternatives: 'Dachangshu (BL 25), Tianshu (ST 25)',
    location: '1st-2nd metacarpal web',
    notes: 'Constipation, diarrhea, bowel disorders, detox.'
  }, {
    bodyPart: 'Shoulders',
    primary: 'Yinlingquan (SP 9)',
    alternatives: 'Jianyu (LI 15), Jianjing (GB 21)',
    location: 'Medial tibia depression',
    notes: 'Shoulder pain, frozen shoulder, rotator cuff injury.'
  }, {
    bodyPart: 'Hips',
    primary: 'Huantiao (GB 30)',
    alternatives: 'Zhibian (BL 54), Juliao (GB 29)',
    location: 'Greater trochanter depression',
    notes: 'Hip pain, sciatica, hip joint problems.'
  }, {
    bodyPart: 'Knees',
    primary: 'Xiyan (EX-LE5)',
    alternatives: 'Yanglingquan (GB 34), Yinlingquan (SP 9)',
    location: 'Patellar depressions',
    notes: 'Knee pain, arthritis, knee joint problems.'
  }, {
    bodyPart: 'Ankles',
    primary: 'Jiexi (ST 41)',
    alternatives: 'Kunlun (BL 60), Zhaohai (KI 6)',
    location: 'Ankle dorsiflexion crease',
    notes: 'Ankle sprains, ankle pain, foot drop.'
  }, {
    bodyPart: 'Qi (Energy)',
    primary: 'Neiguan (PC 6)',
    alternatives: 'Qihai (REN 6), Guanyuan (REN 4)',
    location: '2 cun above wrist crease',
    notes: 'Master point for qi regulation, energy enhancement.'
  }, {
    bodyPart: 'Blood',
    primary: 'Xuehai (SP 10)',
    alternatives: 'Geshu (BL 17), Sanyinjiao (SP 6)',
    location: '2 cun above patella',
    notes: 'Blood disorders, anemia, blood stasis, circulation.'
  }, {
    bodyPart: 'Sinews/Tendons',
    primary: 'Yanglingquan (GB 34)',
    alternatives: 'Danshu (BL 19), Xuanzhong (GB 39)',
    location: 'Fibula head depression',
    notes: 'All tendon and muscle problems, sports injuries.'
  }, {
    bodyPart: 'Bones',
    primary: 'Dazhu (BL 11)',
    alternatives: 'Shenshu (BL 23), Mingmen (GV 4)',
    location: 'T1 level lateral',
    notes: 'Bone disorders, osteoporosis, fractures.'
  }, {
    bodyPart: 'Marrow/CNS',
    primary: 'Xuanzhong (GB 39)',
    alternatives: 'Shenzhu (GV 12), Baihui (GV 20)',
    location: '3 cun above lateral malleolus',
    notes: 'Neurological disorders, spinal cord issues, MS.'
  }, {
    bodyPart: 'Skin',
    primary: 'Quchi (LI 11)',
    alternatives: 'Feishu (BL 13), Hegu (LI 4)',
    location: 'Lateral elbow crease',
    notes: 'All skin disorders, eczema, acne, dermatitis.'
  }, {
    bodyPart: 'Mind/Shen',
    primary: 'Shenmen (HT 7)',
    alternatives: 'Yintang (EX-HN3), Baihui (GV 20)',
    location: 'Wrist crease ulnar side',
    notes: 'Mental disorders, anxiety, depression, consciousness.'
  }, {
    bodyPart: 'Spirit/Hun',
    primary: 'Taichong (LR 3)',
    alternatives: 'Ganshu (BL 18), Hun Men (BL 47)',
    location: '1st-2nd metatarsal junction',
    notes: 'Spiritual issues, dreams, planning, vision.'
  }, {
    bodyPart: 'Willpower/Zhi',
    primary: 'Taixi (KI 3)',
    alternatives: 'Shenshu (BL 23), Zhi Shi (BL 52)',
    location: 'Medial ankle depression',
    notes: 'Lack of willpower, fear, motivation problems.'
  }, {
    bodyPart: 'Thought/Yi',
    primary: 'Taibai (SP 3)',
    alternatives: 'Pishu (BL 20), Yi She (BL 49)',
    location: '1st metatarsal base',
    notes: 'Overthinking, worry, concentration problems.'
  }, {
    bodyPart: 'Corporeal Soul/Po',
    primary: 'Taiyuan (LU 9)',
    alternatives: 'Feishu (BL 13), Po Hu (BL 42)',
    location: 'Radial artery wrist crease',
    notes: 'Grief, letting go, attachment issues.'
  }];
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-299">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 pb-3 border-b-4 border-purple-600" data-id="element-300">
        Hologram Theory - Specific Point Correspondences
      </h2>
      <p className="mb-6 text-gray-700" data-id="element-301">
        <strong data-id="element-302">
          Specific acupuncture points that correspond to body parts and
          functions
        </strong>
      </p>
      <TableWrapper searchTerm={searchTerm} data-id="element-303">
        <table className="w-full border-collapse bg-white rounded-lg overflow-hidden shadow-lg" data-id="element-304">
          <thead data-id="element-305">
            <tr className="bg-gradient-to-r from-purple-600 to-purple-800 text-white" data-id="element-306">
              <th className="p-4 text-left text-sm font-semibold" data-id="element-307">
                Body Part/Function
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-308">
                Primary Point
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-309">
                Alternative Points
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-310">Location</th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-311">
                Clinical Notes
              </th>
            </tr>
          </thead>
          <tbody data-id="element-312">
            {holograms.map((item, index) => <tr key={index} className="border-b border-gray-200 hover:bg-blue-50 transition-colors even:bg-gray-50" data-id="element-313">
                <td className="p-3 font-semibold text-gray-800" data-id="element-314">
                  {item.bodyPart}
                </td>
                <td className="p-3 font-mono text-red-600 font-medium" data-id="element-315">
                  {item.primary}
                </td>
                <td className="p-3 font-mono text-red-600 font-medium" data-id="element-316">
                  {item.alternatives}
                </td>
                <td className="p-3 text-green-700" data-id="element-317">{item.location}</td>
                <td className="p-3 text-purple-700 italic" data-id="element-318">{item.notes}</td>
              </tr>)}
          </tbody>
        </table>
      </TableWrapper>
    </div>;
}